// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1R6Dl","header":"Messages_header__1PLS6"};